import { useState } from "react";
import { FloorSelector } from "./components/floorSelector";
import SideBar from "./components/sideBar";

export default function Controls() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <>
      <FloorSelector className="fixed top-[10px] right-[20px] z-[100]" />
      <SideBar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
    </>
  );
}
